export default function SavedFilterService($http, appSettings) {
  'ngInject';
  const savedFilters = {};
  const savedFilterEndpoint = appSettings.InReachApiSavedFilterEndpoint;

  /**
   * Retrieves all saved searches for the current user
   */
  savedFilters.getAllSavedFilters = function () {
    return $http.get(savedFilterEndpoint);
  };
  /**
   * Retrieves just one saved searches for the current user
   */
  savedFilters.getSavedFilter = function (savedFilterId) {
    return $http.get(savedFilterEndpoint + '/' + savedFilterId);
  };

  /**
   * Save
   */
  savedFilters.postSaveFilter = function (savedFilter) {
    return $http.post(savedFilterEndpoint, savedFilter);
  };
  /**
   * Delete
   */
  savedFilters.deleteSavedFilter = function (savedFilterID) {
    return $http.delete(savedFilterEndpoint + '/' + savedFilterID);
  };
  /**
   * Update
   */
  savedFilters.updateSavedFilter = function (savedFilterId, savedFilter) {
    return $http.put(savedFilterEndpoint + '/' + savedFilterId, savedFilter);
  };
  /**
   * Patch
   */
  savedFilters.patchSavedFilter = function (savedFilterId, savedFilter) {
    return $http.patch(savedFilterEndpoint + '/' + savedFilterId, savedFilter);
  };

  return savedFilters;
}